import React, { cloneElement } from 'react';
import cn from 'classnames';

const OptionsList = ({ children, disabled, onChange, className }) => (
  <div className={cn('onboarding-section_list', className)}>
    {children.map((child, index) =>
      cloneElement(child, {
        key: `child_${index}`,
        disabled,
        onChange,
      }),
    )}
  </div>
);

export default OptionsList;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/OptionsList/OptionsList.js